var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return Array.isArray(_vm.data.dataSource.data.category) && _vm.data.dataSource.data.category.length >= 4 ? _c('MPGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    }
  }, [_c('div', {
    staticClass: "mp-category-grid",
    class: ("mp-category-grid_" + (_vm.data.dataSource.data.category.length))
  }, _vm._l(_vm.data.dataSource.data.category, function (item, index) {
    var _item$image, _item$image2, _item$image3;

    return _c('GGLink', {
      key: index,
      attrs: {
        "to": item.path
      }
    }, [_c('div', {
      staticClass: "mp-category-grid__card"
    }, [_c('img', {
      staticClass: "card__image",
      attrs: {
        "src": (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.x1,
        "srcset": ((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.x2) && (((_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.x2) + " 2x"),
        "alt": ("Пример товара в категории " + (item.name))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card__name-wrapper"
    }, [_c('p', {
      staticClass: "card__name"
    }, [_vm._v(_vm._s(item.name))])])])]);
  }), 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }